import { TFunction } from '@lyearn/i18n';
import { MarkType, MarkTypesEnum } from '@lyearn/lygo-blocks';

export const getCustomMarkType = (t: TFunction, CustomComponent: MarkType['CustomComponent']) => [
  {
    name: MarkTypesEnum.Custom,
    title: t('QuizCreator:AI.Rephrase'),
    CustomComponent,
  },
  { name: MarkTypesEnum.Break, break: 'line' },
];
